import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AdminLogin.css";

const API_ADMIN_LOGIN_URL = `${process.env.REACT_APP_ADMIN_API_URL}/admin-login`;

export const AdminLogin = () => {
  const navigate = useNavigate();

  const [passkey, setPasskey] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setPasskey(e.target.value);
    setError("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!passkey.trim()) {
      setError("Please enter admin passkey");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await axios.post(API_ADMIN_LOGIN_URL, { passkey });

      if (!res.data.success) {
        throw new Error(res.data.message || "Login failed");
      }
      if(res.data.role === "admin"){
        sessionStorage.setItem("admin", "true");
        sessionStorage.setItem("token", res.data.token);
      }
      
      alert("Admin Login Successful");
      sessionStorage.setItem("AdminLogin", true);
      navigate("/adminpanel");
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.message || err.message || "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-top">
          <h1>Admin Login</h1>
          <p>Enter secure passkey</p>
        </div>

        <form className="admin-login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label>Passkey</label>
            <input
              type="password"
              value={passkey}
              onChange={handleChange}
              placeholder="Enter admin passkey"
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button
            type="submit"
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;